import { render, staticRenderFns } from "./BudgetTable.vue?vue&type=template&id=d15a85c6&scoped=true"
import script from "./BudgetTable.vue?vue&type=script&lang=js"
export * from "./BudgetTable.vue?vue&type=script&lang=js"
import style0 from "./BudgetTable.vue?vue&type=style&index=0&id=d15a85c6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a85c6",
  null
  
)

export default component.exports